<template>
    <PerfectScrollbar :options="{ suppressScrollX: true }">
        <div class="np-accordion-list" :class="[state, additionalClasses]">
        <div 
            class="item" 
            v-for="item in items" 
            :key="item.id" 
            :class="{ 'expanded': item.expanded }"
        >
            <!-- Слот для строки элемента -->
            <slot name="item-row" :item="item" :toggle="() => toggleItem(item.id)">
                <!-- Дефолтное минимальное содержимое -->
                <div class="item-row" @click="() => toggleItem(item.id)">
                    {{ item.title }}
                </div>
            </slot>

            <!-- Слот для контента элемента -->
            <div class="content" v-if="item.expanded">
                <!-- Основной слот для sub-item -->
                <slot name="sub-item" :item="item">
                    <div 
                    v-for="subItem in item.subItems" 
                    :key="subItem.id"
                    class="sub-item"
                    @click.stop="() => toggleSubItem(subItem.id)"
                    >
                        {{ subItem.name }}
                    </div>
                </slot>
            </div>
        </div>
        </div>
    </PerfectScrollbar>
</template>

<script>
import { ref, watch } from 'vue'
import IndicatorDaysTo  from "@/components/elements/IndicatorDaysTo.vue"

export default {
    props: {
        items: {
            type: Array,
            default: [],
            validator: (itemsArray) => {
                return itemsArray.every(item => 
                    typeof item === 'object' && 
                    'id' in item && 
                    'title' in item &&
                    'subItems' in item
                );
            }
        },
        subItems: {
            type: Array,
            default: []
        },
        additionalClasses: {
            type: String,
            default: ''
        },
        state: {
            type: String,
            default: ''
        }     
    },
    emits: ['onItemExpand', 'onSubItemExpand'],
    components: {
        IndicatorDaysTo
    },    
    setup(props, { emit }) {
        const toggleItem = (itemId) => {
            const item = props.items.find(i => i.id === itemId)
            if (item) {
                emit("onItemExpand", itemId)
            }
        }

        const toggleSubItem = (itemId) => {
            const item = props.items.flatMap(item => item.subItems).find(i => i.id === itemId)

            if (item) {
                emit("onSubItemExpand", itemId)
            }
        }

        return {
            toggleItem,
            toggleSubItem
        }
    }
}
</script>

<style scoped>
</style>